(function () {
  var deliveryStates = {
    va: [
      ["Springfield", 38.7893, -77.1872],
      ["Alexandria", 38.8048, -77.0469],
      ["Arlington", 38.8799, -77.1068],
      ["Fairfax", 38.8462, -77.3064],
      ["Falls Church", 38.8823, -77.1711],
      ["Annandale", 38.8304, -77.1964],
      ["McLean", 38.9339, -77.1773],
      ["Tysons", 38.9187, -77.2311],
      ["Vienna", 38.9012, -77.2653],
      ["Chantilly", 38.8943, -77.4311],
      ["Reston", 38.9586, -77.3570],
      ["Ashburn", 39.0438, -77.4874]
    ],
    md: [
      ["Bethesda", 38.9847, -77.0947],
      ["Silver Spring", 38.9907, -77.0261],
      ["Chevy Chase", 38.9712, -77.0764],
      ["Potomac", 39.0182, -77.2086],
      ["Rockville", 39.0840, -77.1528],
      ["Kensington", 39.0257, -77.0764],
      ["Takoma Park", 38.9779, -77.0075]
    ],
    dc: [
      ["Georgetown", 38.9097, -77.0654],
      ["Capitol Hill", 38.8899, -77.0091],
      ["Dupont Circle", 38.9096, -77.0434],
      ["Logan Circle", 38.9097, -77.0312],
      ["Downtown DC", 38.9037, -77.0365],
      ["Navy Yard", 38.8747, -77.0059],
      ["Columbia Heights", 38.9280, -77.0320],
      ["Tenleytown", 38.9478, -77.0794]
    ]
  };

  var leafletMap;
  var markerLayer;
  var leafletAttempts = 0;

  function renderLeafletMarkers(state) {
    if (!markerLayer || !deliveryStates[state]) return;

    markerLayer.clearLayers();
    deliveryStates[state].forEach(function (city) {
      L.circleMarker([city[1], city[2]], {
        color: "#454342",
        fillColor: "#eb7f8c",
        fillOpacity: 0.95,
        radius: 6,
        weight: 1
      }).bindPopup(city[0]).addTo(markerLayer);
    });
  }

  function setActiveState(state) {
    if (!deliveryStates[state]) return;

    document.querySelectorAll(".fc-delivery-area__tab").forEach(function (tab) {
      var isActive = tab.dataset.state === state;
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
    });

    document.querySelectorAll(".fc-delivery-area__panel").forEach(function (panel) {
      var isActive = panel.dataset.state === state;
      panel.classList.toggle("is-active", isActive);
      panel.hidden = !isActive;
    });

    renderLeafletMarkers(state);

    if (leafletMap) {
      window.setTimeout(function () {
        leafletMap.invalidateSize();
      }, 0);
    }
  }

  function initDeliveryAreaTabs() {
    var tabs = document.querySelectorAll(".fc-delivery-area__tab");
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      if (tab.dataset.tabsInitialized === "true") return;

      tab.dataset.tabsInitialized = "true";
      tab.addEventListener("click", function () {
        setActiveState(tab.dataset.state);
      });
    });
  }

  function initLeafletMapIfPresent() {
    var mapEl = document.getElementById("fc-delivery-map");
    if (!mapEl || mapEl.dataset.mapInitialized === "true") return;

    if (typeof L === "undefined") {
      leafletAttempts += 1;
      if (leafletAttempts < 20) {
        window.setTimeout(initLeafletMapIfPresent, 150);
      }
      return;
    }

    mapEl.dataset.mapInitialized = "true";

    leafletMap = L.map(mapEl, {
      scrollWheelZoom: false
    }).setView([38.88, -77.18], 10);

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(leafletMap);

    L.circle([38.7893, -77.1872], {
      color: "#eb7f8c",
      fillColor: "#eb7f8c",
      fillOpacity: 0.14,
      radius: 40234,
      weight: 2
    }).addTo(leafletMap).bindPopup("Approximate 25-mile delivery radius from Springfield, VA");

    L.marker([38.7893, -77.1872]).addTo(leafletMap).bindPopup("Flowers' Cuddles area center: Springfield, VA");

    markerLayer = L.layerGroup().addTo(leafletMap);
    renderLeafletMarkers("va");

    window.setTimeout(function () {
      leafletMap.invalidateSize();
    }, 250);
  }

  function initDeliveryArea() {
    initDeliveryAreaTabs();
    initLeafletMapIfPresent();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initDeliveryArea);
  } else {
    initDeliveryArea();
  }
})();
